import { ProductFilters } from "../../types";
import SearchInput from "../input/SearchInput";

interface SortBarProps {
  filters: ProductFilters;
  activeSort: string;
  handleSortChange: (
    sortBy: "created_at" | "price" | "name" | "rating",
    order: "asc" | "desc"
  ) => void;
}

export default function SortBar({ filters, activeSort, handleSortChange }: SortBarProps) {
  return (
    <div className="flex flex-col md:flex-row justify-between mb-10 space-y-4 md:space-y-0">
      <div className="max-w-[450px] w-full">
        <SearchInput placeholder="Поиск..." />
      </div>
      <div className="flex flex-wrap space-x-4">
        <button
          onClick={() => handleSortChange("created_at", "desc")}
          className={`px-2 py-2 rounded-lg text-sm ${activeSort === "created_at" && filters.order === "desc"
              ? "bg-gray-900 text-white"
              : "bg-gray-200 text-gray-700"
            }`}
        >
          Новые
        </button>
        <button
          onClick={() => handleSortChange("price", "asc")}
          className={`px-2 py-2 rounded-lg text-sm ${activeSort === "price" && filters.order === "asc"
              ? "bg-gray-900 text-white"
              : "bg-gray-200 text-gray-700"
            }`}
        >
          По возрастанию
        </button>
        {/* <button
          onClick={() => handleSortChange("rating", "desc")}
          className={`px-2 py-2 rounded-lg text-sm ${activeSort === "rating" && filters.order === "desc"
              ? "bg-gray-900 text-white"
              : "bg-gray-200 text-gray-700"
            }`}
        >
          Популярные
        </button> */}
      </div>
    </div>
  );
}